import { render, staticRenderFns } from "./contrastList.vue?vue&type=template&id=370af2aa&scoped=true"
import script from "./contrastList.vue?vue&type=script&lang=js"
export * from "./contrastList.vue?vue&type=script&lang=js"
import style0 from "./contrastList.vue?vue&type=style&index=0&id=370af2aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370af2aa",
  null
  
)

export default component.exports